<template>

    <el-dialog title="服务选择器" :visible.sync="isSelectServe" width="700px"
               :close-on-click-modal="false" :show-close="false">
        <div class="w100 bg-w serve-select"
             v-loading="loading">
            <el-input  placeholder="请输入服务名称" v-model="paramSearch.serveName"
                       @keyup.enter.native="getServeList"
                       class="w60 mb10"></el-input>
            <div class="cl-f">

                <div class="fl w60" >

                    <div class=" h300p pl20 card-shadow mb5">
                        <el-checkbox v-for="serve in serveList"
                                     v-model="serve.checked"
                                     @change="handleServeChecked($event,serve.serve_id,serve)"
                                     :label="serve.serve_id"
                                     :key="serve.serve_id">{{serve.server_name}}</el-checkbox>
                    </div>

                </div>

                <div class="fr h300p w30 card-shadow" style="overflow: auto">
                    <div class="remark" style="padding: 10px 0;">
                        已选服务(<span class="in-block" style="padding: 0 2px">{{ selectLen }}</span>)个</div>
                    <div class="pl20" style="overflow: auto">

                        <el-checkbox v-for="serve in alreadyData"
                                     :label="serve.serve_id"
                                     v-model="serve.checked"
                                     @change="handleAlreadyChecked"
                                     :key="serve.serve_id">{{serve.server_name}}</el-checkbox>
                </div>
                </div>
            </div>
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="paramSearch.current"
                    :page-size="paramSearch.size"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>

        <div slot="footer" class="dialog-footer" >
            <el-button size="mini" type="primary" @click="sureSelect">确定</el-button>
          <el-button  size="mini" @click="cancel">取消</el-button>

        </div>

    </el-dialog>
</template>

<script>

import { getServePage} from '@/api/managementCenter/serveManage';
export default {
  name: "SelectServe",
  components: {
  },
  props:{
  },
  data() {
    return {
        loading:false,
        isSelectServe:false,
        alreadyData:[],
        alreadyDataId:[],
        serveList:[],
        total:0,
        paramSearch:{
            current:1,
            size:10,
            serveName:''
        }

    };
  },
  computed: {
      selectLen(){
          return this.alreadyData.length
      }

  },
  created() {

  },
  mounted() {

  },
  destroyed() {},
  methods: {
      getServeList(){
          this.loading = true
          getServePage(this.paramSearch).then(({data}) => {
              this.loading = false
              if(data.code == 0){
                  const records = data.data.records||[]
                  this.serveList =records.map(item=>{
                      return{
                          serve_id:item.id,
                          server_name:item.serveName,
                          checked:this.alreadyDataId.indexOf(item.id)==-1?false:true

                      }
                  })
                    this.total=data.data.total
              }else{
                  this.serveList =[]
                  this.$message.warning( data.msg||"加载异常！" );
              }
          }).catch(err=>{
              this.serveList =[]
              this.loading = false
              this.$message.error( "服务器异常!" );
          })
      },
      handleCurrentChange(val) {
          this.paramSearch.current=val
          this.getServeList()
      },

      sureSelect(){

          this.$emit('sureSelect',this.alreadyData)
          this.isSelectServe = false

      },
      cancel(){
          this.isSelectServe = false
      },
      openDialog(data){
          this.isSelectServe = true

          this.alreadyData= data.map(i=>{
              return {...i,checked:true}
          })
          this.$nextTick(()=>{
              this.paramSearch.current=1
              this.paramSearch.size=10
              this.getServeList()
          })


      },
      handleServeChecked(val,id,serve) {
          if(!val){

             const data= this.alreadyData.filter(i=>{
                  return id != i.serve_id
              })
              this.alreadyData =data

          }else{
              this.alreadyData.push(serve)

          }

      },
      handleAlreadyChecked(val){
          if(!val){
              const data=this.alreadyData.filter(i=>{
                  return i.checked
              })
              const obj=this.alreadyData.find(i=>{
                  return !i.checked
              })
              this.serveList.forEach(i=>{
                  if(obj.serve_id == i.serve_id){
                      i.checked=false
                  }
              })
              this.alreadyData =data

          }


      },
  },
  watch: {
      alreadyData(val){
         this.alreadyDataId =val.map(i=>i.serve_id)
      },
      isSelectServe(val){

          if(!val){
              this.alreadyData=[]
                  this.alreadyDataId=[]
                  this.serveList=[]
                  this.total=0
                  this.paramSearch={
                  current:1,
                      size:10,
                      keywords:''
              }
          }
      }
  },
  filters: {}
};
</script>
<style>

  .serve-select .el-checkbox__label{
    width: 120px;
    overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
      margin-bottom: -6px;
  }
  .serve-select .el-checkbox{
    padding: 8px 0;
  }
</style>
